module.exports = __webpack_public_path__ + "img/swiper3.66c66b8f.png";